import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../service/notification.service';
import { AudioService } from '../../service/audio.service';

type NotificationType = 'error' | 'info' | 'success' | 'warning';

type NotificationConfig = {
  type: NotificationType;
  icon: string;
  colorClass: string;
  beepCount?: number;
};

// Interface para gerenciar cada notificação na tela
interface ActiveNotification {
  id: number;
  message: string;
  config: NotificationConfig;
  tag?: string;
}

const NOTIFICATION_MAP: Record<string, NotificationConfig> = {
  error: { type: 'error', icon: 'an an-x-circle', colorClass: 'notify-error', beepCount: 4 },
  info: { type: 'info', icon: 'an an-info', colorClass: 'notify-info' },
  success: { type: 'success', icon: 'an an-check-circle', colorClass: 'notify-success' },
  warning: { type: 'warning', icon: 'an an-warning', colorClass: 'notify-warning', beepCount: 3 },
};

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class NotificationComponent implements OnInit {
  notifications: ActiveNotification[] = [];
  private nextId = 0;

  constructor(
    private notificationService: NotificationService,
    private audioService: AudioService,
  ) {}

  ngOnInit() {
    this.notificationService.showNotification$.subscribe(alertData => {
      this.show(alertData.message, alertData.type, alertData.tag);
    });

    this.notificationService.dismissByTag$.subscribe(tag => {
      this.notifications = this.notifications.filter(n => n.tag !== tag);
    });
  }

  show(message: string, typeAlert: string, tag?: string) {
    const config = NOTIFICATION_MAP[typeAlert] ?? NOTIFICATION_MAP['info'];

    const newNotification: ActiveNotification = {
      id: this.nextId++,
      message: message,
      config: config,
      tag: tag,
    };

    this.notifications.push(newNotification);

    if (config.beepCount) {
      this.audioService.playBeep(config.beepCount);
    }

    if (typeAlert === 'success') {
      setTimeout(() => this.close(newNotification.id), 5000);
    }
  }

  close(id: number) {
    this.notifications = this.notifications.filter(n => n.id !== id);
  }
}
